import AvataUpload from "components/AvataUpload";
import { Form } from "antd";
import React from "react";

const SettingAvatar = () => {
  return (
    <>
      {" "}
      <Form.Item
        name="image"
        rules={[
          {
            required: true,
            message: "กรุณาเพิ่มรูปภาพโปรไฟล์",
          },
        ]}
      >
        <AvataUpload maximumUploadItems={1} />
      </Form.Item>
    </>
  );
};

export default SettingAvatar;
